import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
  searchItems: async ({ searchInput, accountId }) =>
    apiCall(`${config.baseAPIUrl}/task/list/${accountId}?search=${searchInput}&type=account`, {
      method: 'POST',
    }),
}
